/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".min-max{background-color:#fff;padding:15px}.min-max>div{margin-bottom:5px}.min-max>div>label{margin:10px 0}.min-max .button-container{margin-top:15px;text-align:right}.btn{margin-bottom:5px;margin-right:5px}select option:disabled{background-color:#d3d3d3;font-weight:700}"];
export { styles as styles };
